var map = {
	"./afterwave.md": 72,
	"./build-tools.md": 73,
	"./code-quality.md": 74,
	"./css-framework.md": 75,
	"./css-modern.md": 76,
	"./css-preprocessor.md": 77,
	"./css.md": 78,
	"./data-view.md": 79,
	"./desktop-app.md": 80,
	"./editor.md": 81,
	"./git.md": 82,
	"./how-does-the-browser-work.md": 83,
	"./how-does-the-internet-work.md": 84,
	"./html.md": 85,
	"./javascript.md": 86,
	"./js-framework.md": 87,
	"./learn-from-github.md": 88,
	"./mini-app.md": 89,
	"./mobile-app.md": 90,
	"./node.md": 91,
	"./performance.md": 92,
	"./ssr.md": 93,
	"./static-site.md": 94,
	"./temp-md.md": 95,
	"./test-framework.md": 96,
	"./web-assembly.md": 97,
	"./webview.md": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;